import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { ERankTrackerPerformanceOvertimeTabs } from "app/components/campaigns/shared/overview/types";
import { EFamilyTypes } from "app/components/dashboard/dashboard-templates/components/DashboardTemplatesTypes";
import { translate } from "app/filters/i18nFilter";
import { getAPIPrefixForRT } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsInfraUtils";
import { DEFAULT_POSITION_SORTING } from "app/common/campaigns/KeywordsCampaginKeywordsTableConsts";
import { EKeywordsReportKeywordsTableMetrics } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsReportTypes";

export const RankTrackerKeywordsReportTable = {
    id: "RankTrackerKeywordsReportTable",
    properties: {
        width: 2,
        dashboard: "true",
        useCampaignsSelectors: true,
        metric: "RankTrackerKeywordsReportTable",
        hasWebSource: true, //used for the web source icon in the widget title
        get title() {
            return translate("dashboard.metric.rankTracker.kwReport.title");
        },
        order: "1",
        family: EFamilyTypes.RankTracker,
        component: "RankTracker", //required for edit and create widget
        endpoint: `${getAPIPrefixForRT(false)}/reports/keywordsReport`, //KEYWORDS_REPORT_TABLE_API_URL
        state: "ranktracker.keywords",
        viewPermissions: {
            trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        isHidden: false,
        options: {
            deviceFilteringUnavailable3: true,
            scrollableTable: true,
            showLoadMore: true,
        },
        apiParams: {
            tableTab: EKeywordsReportKeywordsTableMetrics.POSITION,
            tableGranularity: GranularityNames.DAILY,
            graphGranularity: GranularityNames.DAILY,
            sort: DEFAULT_POSITION_SORTING,
            asc: false,
            isDaily: true,
        },
    },
    widgets: {
        single: {
            defaultType: "RankTrackerKeywordsReportTable",
            RankTrackerKeywordsReportTable: {
                properties: {
                    showMoreButtonItems: 2,
                    options: {
                        showLegend: false,
                    },
                },
            },
        },
        compare: {
            defaultType: "RankTrackerKeywordsReportTable",
            RankTrackerKeywordsReportTable: {
                properties: {
                    showMoreButtonItems: 2,
                    options: {
                        showLegend: false,
                    },
                },
            },
        },
    },
};

export const RankTrackerOverviewVisibility = {
    id: "RankTrackerOverviewVisibility",
    properties: {
        dashboard: "true",
        metric: "RankTrackerOverviewVisibility",
        hasWebSource: true,
        get title() {
            return translate("dashboard.metric.rankTracker.overview.visibility.title");
        },
        order: "1",
        family: EFamilyTypes.RankTracker,
        component: "RankTracker",
        endpoint: "api/rankTracker/reports/overviewReport",
        state: "ranktracker.overview",
        viewPermissions: {
            trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        isHidden: false,
        apiParams: {
            graphTab: ERankTrackerPerformanceOvertimeTabs.VISIBILITY,
            timeGranularity: GranularityNames.DAILY,
        },
    },
    widgets: {
        single: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Visibility",
                    type: "percentage",
                    format: "percentagesign",
                    formatParameter: 1,
                    name: "Keyword Visibility",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    // these options are merged to widget._viewOptions object
                    options: {
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Visibility",
                    type: "percentage",
                    format: "percentagesign",
                    formatParameter: 1,
                    name: "Keyword Visibility",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
};

export const RankTrackerOverviewWeightedAvgPosition = {
    id: "RankTrackerOverviewWeightedAvgPosition",
    properties: {
        dashboard: "true",
        metric: "RankTrackerOverviewWeightedAvgPosition",
        hasWebSource: true,
        get title() {
            return translate("dashboard.metric.rankTracker.overview.weighted_avg_position.title");
        },
        order: "1",
        family: EFamilyTypes.RankTracker,
        component: "RankTracker",
        endpoint: "api/rankTracker/reports/overviewReport",
        state: "ranktracker.overview",
        viewPermissions: {
            trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        isHidden: false,
        apiParams: {
            graphTab: ERankTrackerPerformanceOvertimeTabs.AVG_WEIGHTED_POSITION,
            timeGranularity: GranularityNames.DAILY,
        },
    },
    widgets: {
        single: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keywords Weighted Avg. Position",
                    type: "long",
                    format: "number",
                    formatParameter: 0,
                    name: "Keywords Weighted Avg. Position",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    // these options are merged to widget._viewOptions object
                    options: {
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keywords Weighted Avg. Position",
                    type: "long",
                    format: "number",
                    formatParameter: 0,
                    name: "Keywords Weighted Avg. Position",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
};

export const RankTrackerOverviewClicks = {
    id: "RankTrackerOverviewClicks",
    properties: {
        dashboard: "true",
        metric: "RankTrackerOverviewClicks",
        hasWebSource: true,
        get title() {
            return translate("dashboard.metric.rankTracker.overview.clicks.title");
        },
        order: "1",
        family: EFamilyTypes.RankTracker,
        component: "RankTracker",
        endpoint: "api/rankTracker/reports/overviewReport",
        state: "ranktracker.overview",
        viewPermissions: {
            trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        isHidden: false,
        apiParams: {
            graphTab: ERankTrackerPerformanceOvertimeTabs.CLICKS,
            timeGranularity: GranularityNames.DAILY,
        },
    },
    widgets: {
        single: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Clicks",
                    type: "long",
                    format: "number",
                    formatParameter: 0,
                    name: "Keyword Clicks",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    // these options are merged to widget._viewOptions object
                    options: {
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Clicks",
                    type: "long",
                    format: "number",
                    formatParameter: 0,
                    name: "Keyword Clicks",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
};

export const RankTrackerOverviewShareOfVoice = {
    id: "RankTrackerOverviewShareOfVoice",
    properties: {
        dashboard: "true",
        metric: "RankTrackerOverviewShareOfVoice",
        hasWebSource: true,
        get title() {
            return translate("dashboard.metric.rankTracker.overview.voice.title");
        },
        order: "1",
        family: EFamilyTypes.RankTracker,
        component: "RankTracker",
        endpoint: "api/rankTracker/reports/overviewReport",
        state: "ranktracker.overview",
        viewPermissions: {
            trafficSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        isHidden: false,
        apiParams: {
            graphTab: ERankTrackerPerformanceOvertimeTabs.SHARE_OF_VOICE,
            timeGranularity: GranularityNames.DAILY,
        },
    },
    widgets: {
        single: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Share Of Voice",
                    type: "percentage",
                    format: "percentagesign",
                    formatParameter: 1,
                    name: "Keyword Share Of Voice",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "RankTrackerOverviewPerformanceGraph",
            RankTrackerOverviewPerformanceGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    // these options are merged to widget._viewOptions object
                    options: {
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Keyword Share Of Voice",
                    type: "percentage",
                    format: "percentagesign",
                    formatParameter: 1,
                    name: "Keyword Share Of Voice",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
};
